import React from "react";
import styles from "./FunnelAssessmentCard.module.css";
import { parseAssessmentBlock } from "./assessmentUtils";

const FunnelAssessmentCard = ({ markdown, meta = {} }) => {
  const parsed = parseAssessmentBlock(markdown);
  if (!parsed) return null;

  const subtitle = meta.subtitle || "Assessment signal";
  const badge = meta.badge || "ASSESSMENT";

  
  return (
    <div className={styles.card}>
      <div className={styles.hero}>
        <div>
          <h4 className={styles.heroTitle}>{parsed.title}</h4>
          <p className={styles.heroSubtitle}>{subtitle}</p>
        </div>
        <div className={styles.heroBadge}>{badge}</div>
      </div>

      {parsed.metrics.length > 0 ? (
        <div className={styles.section}>
          <div className={styles.sectionLabel}>Key Signals</div>
          {parsed.metrics.map((metric, idx) => (
            <div key={`${metric}-${idx}`} className={styles.row}>
              <span className={styles.dot} />
              <span>{metric}</span>
            </div>
          ))}
        </div>
      ) : null}

      {parsed.interpretation ? (
        <div className={styles.section}>
          <div className={styles.sectionLabel}>Interpretation</div>
          <p className={styles.sectionText}>{parsed.interpretation}</p>
        </div>
      ) : null}

      {parsed.whatThisMeans ? (
        <div className={styles.section}>
          <div className={styles.sectionLabel}>What This Means</div>
          <p className={styles.sectionText}>{parsed.whatThisMeans}</p>
          <div className={styles.sectionAccentRow}>
            <div className={styles.sectionAccentLeft} />
            <span className={styles.sectionAccentLabel}>{badge}</span>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default FunnelAssessmentCard;
